import React, { useState } from 'react'
import styled from 'styled-components'
import { Tooltip } from '@material-ui/core'
import Link from '../StyledLink'
import logo from '../../assets/tr_h_lg_rgb_wh.svg'

const Graphics = styled.span`
  font-family: knowledge2017bold;
`

const LogoText = styled.div`
  font-family: knowledge2017regular;
  font-size: 16px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  margin-left: 8px;
  color: white;
`

export const HeaderLogo = ({ overlayIsShown }) => {
  const [tooltipOpen, setTooltipOpen] = useState(false)
  return (
    <Tooltip
      title="Home"
      open={tooltipOpen && !overlayIsShown}
      onMouseOverCapture={() => {
        setTooltipOpen(true)
      }}
      onMouseOutCapture={() => {
        setTooltipOpen(false)
      }}
    >
      <Link id="home" to="/" invisible="true" wrapped="true">
        <img src={logo} alt="Thomson Reuters" />
        <LogoText>
          Reuters <Graphics>Graphics</Graphics>
        </LogoText>
      </Link>
    </Tooltip>
  )
}
